import { api } from "./client.js";
import type { Bulletin, CreateBulletinBody, PatchBulletinBody } from "@wwrp/shared";

export const bulletinsApi = {
  list: () => api.get<Bulletin[]>("/bulletins"),
  create: (body: CreateBulletinBody) => api.post<Bulletin>("/bulletins", body),
  update: (id: number, body: PatchBulletinBody) => api.patch<Bulletin>(`/bulletins/${id}`, body),
  remove: (id: number) => api.delete<{ ok: true }>(`/bulletins/${id}`),
};
